var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.54,
    height: 16.3,
    viewBox: "0 0 13.54 16.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9369",
    "data-name": "Path 9369",
    d: "M114.837,0h-11a.5.5,0,0,0-.5.5V2h1V1h10V15h-10V14h-1v1.5a.5.5,0,0,0,.5.5h11a.5.5,0,0,0,.5-.5V.5a.5.5,0,0,0-.5-.5Z",
    transform: "translate(-102.097 0)",
    fill: "#39be9d",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9370",
    "data-name": "Path 9370",
    d: "M39.385,166.051l.707.707,3.353-3.354-3.353-3.353-.707.707,2.146,2.146H34.446v1h7.086Z",
    transform: "translate(-34.446 -155.405)",
    fill: "#39be9d",
    stroke: "#39be9d",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGreen);
export default __webpack_public_path__ + "static/media/login-green.395afef14acac21672a44344162f4cad.svg";
export { ForwardRef as ReactComponent };